import { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { useSite } from '@labradorsports/utils';

import { Selectors } from '../../store/index.js';
import { ProgramLogo } from '../index.js';
import TeamsMenuItem from '../teams-menu-item/teams-menu-item.js';

interface Props {
    program: Program;
    teams: any[];
    selectTeam: (team: Team) => void;
    leaveTeam: (team: Team) => void;
    favoriteTeam: (team: Team) => void;
}

const TeamsMenuProgram: FC<Props> = ({ program, teams, selectTeam, leaveTeam, favoriteTeam }) => {
    const { Config } = useSite();
    const uid = useSelector(Selectors.uid);
    const profileSettings = useSelector(Selectors.profileSettings);

    if (!teams?.length) {
        return null;
    }

    const teamNodes = teams
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((team, idx) => {
            return (
                <Fragment key={team.id}>
                    {idx > 0 ? <hr className="team-separator" /> : null}
                    <TeamsMenuItem
                        team={team}
                        program={program}
                        selectTeam={selectTeam}
                        uid={uid}
                        leaveTeam={leaveTeam}
                        favoriteTeam={favoriteTeam}
                        isFavorite={profileSettings?.favoriteTeams?.[Config.SiteConfig.Site] === team.id}
                    />
                </Fragment>
            );
        });

    return (
        <div className="teams-menu-program">
            <div className="program-header">
                <ProgramLogo program={program} />
                <span className="program-name">{program.name}</span>
                <span className={`program-status ${program.paid ? '' : 'text-danger'}`}>
                    {program.paid ? 'Active' : 'Inactive'}
                </span>
            </div>
            <div className="program-teams">{teamNodes}</div>
        </div>
    );
};
export default TeamsMenuProgram;
